<div class="crop-edge-modal">
  <div class="crop-edge-page">
    <div class="head-sec">
      <h3 class="margin-b10">SELECT AN ACCOUNT TO PROCEED:</h3>
      <h4>Please select an account that you’d like to view in CropEdge by choosing an option below.</h4>
    </div>
    <div class="crop-edge-bottom">
      <div class="row accountPageTopFilter margin-t20">
        <div class="col-md-12 col-lg-12">
          <app-efulfillmentfilter [disableSearchBtn]="isSetEmulation" [filters]="filterArray" [cleanFilter]="cleanAccount" (SearchFilter)="filterGrid($event)" [IsPartnerWebSiteTab]='true' [IsFulfillment]='true'></app-efulfillmentfilter>
        </div>
      </div>
      <div class="">
        <div class="row">
          <div class="col-md-12">
            <div class="tableContainer">
              <table class="matTables mat-table">

                <tbody *ngIf="attachedAccountsList.length != 0 ; else noRecordAA">
                  <tr *ngFor="let item of attachedAccountsList">
                    <td class="mat-cell text-left accNo" (click)="accountClick(item.crossRefValue)">
                      <p class="attachAccountNo margin-b0">Account # : {{item.account}}</p>
                      <p class="account-name margin-b0">{{item.accountName}}</p>
                    </td>
                    <td class="mat-cell text-left xref">X-REF ID : {{item.crossRefValue}}</td>
                    <td class="mat-cell text-right addresss">
                      <p>{{item.address1}} ,{{item.city}},{{item.state}} {{item.zip}}</p>
                    </td>
                  </tr>
                </tbody>
                <ng-template #noRecordAA>
                  <tbody>
                    <tr>
                      <td colspan="4" class="mat-cell">
                        <div class="noRecordMsg">
                          No Record Found.
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </ng-template>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-block">
      <div class="text-right">
        <button mat-raised-button class="btns mat-button" id="dialog-close" (click)="closeDialog();" type="button">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
